import { createContext } from 'react';

export const initialState = {
  filters: {
    idWarecloud: '',
    status: 'pending',
    idRoute: '',
    orderSearch: '',
  },
  setFilters: () => {},
  openBarcodeScanner: false,
  setOpenBarcodeScanner: () => {},
  openManualReceiving: false,
  setOpenManualReceiving: () => {},
};

export const CrossdockingContext = createContext(initialState);
